import React, { useEffect } from 'react';

// Force dark mode always
function applyDarkMode() {
  if (typeof document === 'undefined') {
    return;
  }

  const root = document.documentElement;
  root.dataset.theme = 'dark';
  root.classList.add('dark');
}

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    applyDarkMode();
  }, []);

  return <>{children}</>;
}

export function ColorSchemeScript() {
  const script = `(() => {
    try {
      document.documentElement.dataset.theme = 'dark';
      document.documentElement.classList.add('dark');
    } catch (error) {
      console.error('Failed to apply dark mode', error);
    }
  })();`;

  return <script dangerouslySetInnerHTML={{ __html: script }} />;
}
